var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"MAXcontainer",class:this.size.w == 0 || this.size.h == 0 ? 'container' : ''},[_vm._t("default"),_c('div',{ref:"container",class:this.size.w == 0 || this.size.h == 0 ? 'container' : ''})],2)}
var staticRenderFns = []

export { render, staticRenderFns }